'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '../contexts/AuthContextNext';
import { initMixpanel } from '../lib/mixpanel';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

let mixpanelInitialized = false;

export function Providers({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Mixpanel only once
    if (!mixpanelInitialized && typeof window !== 'undefined') {
      initMixpanel();
      mixpanelInitialized = true;
    }
  }, []);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          {children}
        </AuthProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
} 